import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import {createStore, applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Promise from 'promise-polyfill';
import rootReducer from './reducers/rootReducer';

import {persistStore, autoRehydrate} from 'redux-persist'
import {asyncSessionStorage} from 'redux-persist/storages'
import {createMediaStyle, MediaContextProvider} from "./AppMedia"

let store = createStore(
    rootReducer,
    autoRehydrate(),
    applyMiddleware(thunk)
);

if (!window.Promise) {
    window.Promise = Promise;
}

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

// axios.defaults.baseURL = 'https://api.example.com';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

persistStore(store, {
    blacklist: ["routing", "chat", "events", "outlook", "voice"],
    storage: asyncSessionStorage
}, () => {
    ReactDOM.render(
        <Provider store={store}>
            <MediaContextProvider>
                <App/>
            </MediaContextProvider>
        </Provider>
        , document.getElementById('root'));
    registerServiceWorker();
})





// WEBPACK FOOTER //
// ./src/index.js